var map = {
	"./Framabag.vue": 109,
	"./Framabee.vue": 107,
	"./Framabin.vue": 110,
	"./Framaboard.vue": 111,
	"./Framabookin.vue": 112,
	"./Framacalc.vue": 113,
	"./Framaclic.vue": 114,
	"./Framadrop.vue": 115,
	"./Framaestro.vue": 116,
	"./Framalink.vue": 117,
	"./Framanews.vue": 118,
	"./Framanotes.vue": 119,
	"./Framapic.vue": 120,
	"./Framasite.vue": 121,
	"./Framaslides.vue": 122,
	"./Framasphere.vue": 123,
	"./Framastory.vue": 124,
	"./Framavectoriel.vue": 125,
	"./Framawiki.vue": 126,
	"./Framemo.vue": 127,
	"./Framindmap.vue": 128,
	"./Home.vue": 108,
	"./Myframa.vue": 129
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16;